export default "__VITE_ASSET__CA71DALm__"